import { useEffect, useState } from 'react';
import { Countries } from 'shared/enums';
import { shallow } from 'zustand/shallow';
import { defaultData } from '../constants';
import {
  calculateMetrics,
  calculateMustHaveTotal,
  calculateOptional,
  getRowIdsByPriority,
} from '../utils';
import { useTotalOfflineBudgetStore } from '../../../../../../../../../../store/offlineTotalBudgetStore';
import { FooterData, UseFooterDataProps } from '../types';
import usePlanStore from '../../../../../../../../../../store/planStore';

const useFooterData = ({
  rows,
  optionalIds,
  country = Countries.POLAND,
  currency = 'PLN',
}: UseFooterDataProps) => {
  const { updateOfflineBudget } = useTotalOfflineBudgetStore(
    (state) => ({ updateOfflineBudget: state.updateOfflineBudget }),
    shallow
  );

  const { countryForms, selectedCountry } = usePlanStore();

  const tvBudget = countryForms[selectedCountry!].offline?.tv?.calculatedBudget;

  const [footerData, setFooterData] = useState<FooterData>(defaultData);

  useEffect(() => {
    const mustHaveIds = getRowIdsByPriority(rows, true);

    const newFooterData = {
      totalOffline: calculateMetrics(
        (metric) =>
          (tvBudget?.copies?.reduce(
            (acc, copy) => acc + (copy.campaignBudget?.value || 0),
            0
          ) ?? 0) +
          calculateMustHaveTotal(metric, rows, mustHaveIds) +
          calculateOptional(metric, rows, optionalIds)
      ),
      // otherCosts: calculateMetrics((metric) =>
      //   calculateOptional(metric, rows, optionalIds)
      // ),
      techCosts: calculateMetrics(() => tvBudget?.techCost?.value ?? 0),
      totalBudget: calculateMetrics(
        (metric) =>
          rows
            .filter((row) => row.isIncludedInCalculations)
            .reduce((acc, row): number => acc + (row.budget.value || 0), 0) +
          // calculateOptional(metric, rows, optionalIds) +
          (tvBudget?.techCost?.value ?? 0) +
          (tvBudget?.copies?.reduce(
            (acc, copy) => acc + (copy.campaignBudget?.value || 0),
            0
          ) ?? 0)
      ),
    };

    newFooterData.totalOffline.weeks = tvBudget?.copies?.[0].weeks ?? 0;
    newFooterData.totalOffline.grp =
      tvBudget?.copies?.reduce((acc, copy) => acc + (copy.totalGrp || 0), 0) ??
      0;

    updateOfflineBudget(country, {
      totalOffline: newFooterData.totalOffline.budget,
      // otherCosts: newFooterData.otherCosts.budget,
      techCosts: newFooterData.techCosts.budget,
      totalBudget: newFooterData.totalBudget.budget,
    });
    setFooterData(newFooterData);
  }, [rows, optionalIds, currency, updateOfflineBudget, country]);
  return footerData;
};

export default useFooterData;
